import React, { useEffect } from 'react';
import Spinner from './generic-components/Spinner';
import reducer, { store as initialState } from '../src/hooks/useStore';
import { fetchSimoSubscription } from './hooks/helperFunctions';

export const AppContext = React.createContext(null);

export const ContextWrapper = (props) => {
  const [store, dispatch] = React.useReducer(reducer, initialState);
  useEffect(() => {
    const getSimoSubscription = async () => {
      try {
        const response = await fetchSimoSubscription();
        dispatch({ type: 'getSubscriptions', payload: response });
      } catch (error) {
        console.log(error);
      }
    };
    getSimoSubscription();
  }, [store.fatalError]);
  return store.loadingGlobal ? (
    <Spinner />
  ) : (
    <AppContext.Provider value={{ store, dispatch }}>{props.children}</AppContext.Provider>
  );
};
